import { render, staticRenderFns } from "./warningStatement.vue?vue&type=template&id=9c49f8d0&"
import script from "./warningStatement.vue?vue&type=script&lang=js&"
export * from "./warningStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports